export default __webpack_public_path__ + "static/content-containers-dark-49065fb4269890ef0891210def36603c54ba1c735770204cb8f68f6516785f03.png";